import { Component, Input, input, OnDestroy, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Bundle, BundleOrderGroupsRepositoryService, ConfirmDialogComponent, Order, OrderManagerService, SlideDownAnimation } from 'reg-hub-common';
import { Subject, takeUntil } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-order-bundles',
    templateUrl: './order-bundles.component.html',
    styleUrl: './order-bundles.component.css',
    animations: [SlideDownAnimation],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderBundlesComponent implements OnInit, OnDestroy {
  private readonly transloco = inject(TranslocoService);
  private onDestroy$ = new Subject<void>();
  bundles: Bundle[] = [];
  order!: Order;
  displayedColumns: string[] = ['name', 'navigate', 'delete'];

  protected collapsed = false;
  protected collapseHasBeenToggled = false;

  constructor(private router: Router,
    private orderManager: OrderManagerService,
    private bundleOrderGroupsRepo: BundleOrderGroupsRepositoryService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.orderManager.currentOrder
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(order => {
        this.order = order;
        this.bundles = order.orderGroup?.bundles ?? [];
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onCollapse() {
    this.collapsed = !this.collapsed;
    this.collapseHasBeenToggled = true;
  }

  navigateToBunde(bundleID: string) {
    const url = this.router.serializeUrl(
        this.router.createUrlTree(['bundles', bundleID], { queryParams: { tab: 'orders' }})
      );

      window.open(url, '_blank');
  }

  deleteBundleOrderGroupConfirmation(bundleID: string) {
    var bundleName = this.bundles.find(bundle => bundle.id == bundleID)?.name ?? "";
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          data: {
            title: this.transloco.translate('orders.removeFromBundle'),
            confirmationPrompt: this.transloco.translate('orders.confirmPermanentlyRemoveThisOrderGroup', { bundleName: bundleName }),
            positiveResponseLabel: this.transloco.translate('common.buttons.delete'),
            negativeResponseLabel: this.transloco.translate('common.buttons.cancel')
          },
          minWidth: '800px'
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // submission is confirmed, submit order
            this.deleteBundleOrderGroup(bundleID);
          }
        });
  }

  deleteBundleOrderGroup(bundleID: string) {
    var bundle = this.bundles.find(bundle => bundle.id == bundleID);
    this.bundleOrderGroupsRepo.deleteBundleOrderGroup(bundle!.corporationID, bundle!.id, this.order.orderGroup!.id)
    .subscribe({
      next: () => {
        this.order.orderGroup!.bundles = this.order.orderGroup!.bundles!.filter(bundle => bundle.id !== bundleID);
        this.orderManager.updateOrder(this.order);
      }
    })
  }
}
